import { render, staticRenderFns } from "./WarningStrategy.vue?vue&type=template&id=687fda2a&"
import script from "./WarningStrategy.vue?vue&type=script&lang=js&"
export * from "./WarningStrategy.vue?vue&type=script&lang=js&"
import style0 from "./WarningStrategy.vue?vue&type=style&index=0&id=687fda2a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports